const { getNumericValueWithDecimals } = require('../../analyticUtils');
const { analyticsEventBus, ANALYTICS_EVENTS } = require('../../events');
const { clickedItemListStorage } = require('../../stores/itemList');
const { createCustomEventGA4 } = require('../models/customEventGA4');
const { createEcommerceEventGA4 } = require('../models/ecommerceEventGA4');
const {
  createEcommerceEventItemsGA4,
} = require('../models/ecommerceEventItemsGA4');
const pushEvent = require('../pushEvent');

/* -------------------------------------------------------------------------- *\
 * PDP EVENTS                                                                 *
 * ----------                                                                 *
 * - Item Clicked                                                             *
 * - Product Details Viewed                                                   *
\* -------------------------------------------------------------------------- */

/**
 * Subscribe to our analytics events and push to dataLayers
 */
function subscribeToAnalyticsEvents() {
  // Item Clicked
  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.productDetailsItemClicked,
    (item) => {
      pushEvent(
        createCustomEventGA4('product_info', [
          ['action', 'click'],
          ['item', item],
        ])
      );
    }
  );

  // Product Details Viewed
  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.productDetailsViewed,
    (payload) => {
      const productData = {
        ...payload.product,
        itemProps: {
          product_id_with_size: undefined,
        },
      };
      pushEvent(
        createEcommerceEventGA4(
          'view_item',
          createEcommerceEventItemsGA4([productData], {
            itemListStorage: clickedItemListStorage,
          }),
          {
            currency: gaInfo.currencyCode,
            value: getNumericValueWithDecimals(
              payload.product?.price?.sales?.decimalPrice
            ),
          }
        )
      );
    }
  );

  analyticsEventBus.subscribe(
    analyticsEventBus.EVENTS.crossSellingGridOpened,
    /**
     * Handle the analytics a cross selling modal is opened
     * @param {Object} payload Event payload
     * @param {string} payload.categoryId The ID of the category of the related
     *  products
     */
    ({ categoryId }) => {
      if (categoryId) {
        pushEvent(
          createCustomEventGA4('related_category_recommendation', [
            ['action', 'click'],
          ])
        );
      }
    }
  );
}

module.exports = {
  subscribeToAnalyticsEvents,
};
